import React, { useState } from 'react'
import { Box, IconButton, Popover, Typography } from '@mui/material'
import Info from 'assets/teacher/info.svg'

type InfoIconWithPopoverProps = {
  tooltip: string | React.ReactNode
}

function InfoIconWithPopover({ tooltip }: InfoIconWithPopoverProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        sx={{ ml: 1 }}
        onClick={handleClick}
        aria-describedby={open ? 'info-popover' : undefined}
      >
        <Box
          component='img'
          src={Info}
          alt='Info'
          sx={{ width: 20, height: 20 }}
        />
      </IconButton>
      <Popover
        id='info-popover'
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          {typeof tooltip === 'string' ? (
            <Typography variant='body2'>{tooltip}</Typography>
          ) : (
            tooltip
          )}
        </Box>
      </Popover>
    </>
  )
}

export default InfoIconWithPopover
